import { Component, input } from '@angular/core';

@Component({
  selector: 'rid-rule-card',
  imports: [],
  templateUrl: './rid-rule-card.html',
})
export class RidRuleCard {
  rule = input.required<string>();
  appearance = input<'DEFAULT' | 'INCORRECT' | 'CORRECT'>('DEFAULT');
}
